import FacetPanelLoading from '../panels/facet_panel_loading';

const FacetPreloader = () => {
  return (
    <>
      {Array.from(
        {
          length: 5
        },
        (_element, index) => (
          <FacetPanelLoading key={index} />
        )
      )}
    </>
  );
};

export default FacetPreloader;
